import React, { useState, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Button, Drawer, Tag, Dropdown, Select } from 'antd';
import {
  PhoneOutlined,
  EditOutlined,
  MailOutlined,
  CaretDownFilled,
  FilterOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import Constants, { CountryCodes } from '@Apis/constants';
import searchIcon from '@Images/icons/icon-search.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantActions from '@Actions/tenantActions';
import AnalyticsActions from '@Actions/application/analyticsActions';
import CustomerActions from '@Actions/customerActions';




import VendorForm from '../../Common/VendorForm';
import './style.scss';
import CustomerForm from '../../Sales/Customer/CustomerHome/CreateCustomer/CustomerForm';
import PRZSelect from '../../Common/UI/PRZSelect';

const { Option } = Select;

const Customers = ({
  getOrgCustomersLoading,
  user,
  getOrgCustomers,
  history,
  commonGetRequests,
  orgCustomers
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [showNewCustomerModal, setShowNewCustomerModal] = useState(false);
  const [showUpdateVendorModal, setShowUpdateVendorModal] = useState(false);
  const [mobileVendorsLength, setMobileVendorsLength] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isCustomerArchive, setIsCustomerArchive] = useState('false');

  const productListColumns = [
    {
      title: 'CUSTOMER #',
      render: (text, record) => <Fragment>{record?.internal_cust_code || '-'}</Fragment>,
    },
    {
      title: 'NAME',
      key: 'name',
      render: (text, record) => (
        <div>
          {record?.customer_name}
        </div>
      ),
    },
    {
      title: 'EMAIL',
      render: (text, record) => (
        <Fragment>{record?.email_address || '-'}</Fragment>
      ),
    },
    {
      title: 'CONTACT NUMBER',
      render: (text, record) => (
        <Fragment>
          {record?.phone_number ? (
            `${CountryCodes?.find((code) => code?.dial_code == record?.dial_code)?.flag} +${record?.dial_code} ${record?.phone_number}`
          ) : '-'}
        </Fragment>
      ),
    },
    {
      title: 'AVAILABLE STORES',
      render: (text, record) => record?.tenant_customers?.length || '0',
    },
  ];

  useEffect(() => {
    if (user) {
      getOrgCustomers(null, currentPage, 10, isCustomerArchive);
    }
  }, [user, currentPage, isCustomerArchive]);

  const getCustomerssWithKey = (customersData) => {
    const customersCopy = JSON.parse(JSON.stringify(customersData));
    for (let i = 0; i < customersCopy?.length; i++) {
      customersCopy[i].key = i;
    }
    return customersCopy;
  };

  const customerOptionsArchive = [
    {
      label: 'Active',
      value: 'false',
    },
    {
      label: 'Archived',
      value: 'true',
    },
  ];

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for customer name.."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            getOrgCustomers(e.target.value, currentPage, 10, isCustomerArchive);
                            setKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          getOrgCustomers('', currentPage, 10, isCustomerArchive);
                          setKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Customer"
                      onClick={() => {
                        setShowNewCustomerModal(true);
                      }}
                      customClass="add-button"
                    />
                  </div>
                )}
              </div>
            </div>
            {keyword && keyword.length > 0 && (
              <div className="search-bar__search-container__clear-button">
                <H3Text
                  text={(
                    <React.Fragment>
                      Showing search results for&nbsp;
                      <i>
                        <b>
                          {`'${keyword}'`}
                        </b>
                      </i>
                    </React.Fragment>
                  )}
                  className="section-search-keyword"
                />
                <H3Text
                  text="clear"
                  className="search-bar__clear-button"
                  onClick={() => {
                    setKeyword('');
                    setCurrentPage(1);
                    getOrgCustomers('', 1, 10, isCustomerArchive);
                  }}
                />
              </div>
            )}
            {/* <div className="customers__table__wrapper"> */}
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text
                        text={`${orgCustomers?.count || '0'
                          } ${(isCustomerArchive === 'true' || isCustomerArchive === true)
                            ? 'Archived'
                            : 'Active'
                          } Customers`}
                        className=""
                      />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        {selectedRowKeys?.length > 0 && (
                          <Dropdown
                            overlay={(
                              <div className="custom-columns__sort-filter">
                                <H3Text
                                  text={(isCustomerArchive == 'true' || isCustomerArchive == true) ? 'Activate' : 'Archive'}
                                  className="header__custom-dropdown__option"
                                  onClick={() => {
                                    const selectedIds = selectedRows?.map((item) => item?.customer_id);
                                    const apiUrl = (isCustomerArchive === 'true' || isCustomerArchive === true) ? Constants.UNARCHIVE_CUSTOMERS : Constants.ARCHIVE_CUSTOMERS;
                                    commonGetRequests({
                                      url: `${apiUrl}?customer_ids=${selectedIds}`,
                                    }, () => {
                                      setSelectedRows([]);
                                      setSelectedRowKeys(null);
                                      getOrgCustomers('', 1, 10, isCustomerArchive);
                                    });
                                  }}
                                />
                              </div>
                            )}
                            trigger={['click']}
                            placement="bottomRight"
                          >
                            <div className="action-buttons">
                              <div className="action-button">
                                <H3Text text="Actions" className="action-button-text" />
                                <CaretDownFilled style={{ paddingBottom: '3px' }} />
                              </div>
                            </div>
                          </Dropdown>
                        )}
                      </div>
                      <div
                        className="filter__container filter__container-section customer-status-selector"
                      >
                        <PRZSelect
                          value={isCustomerArchive}
                          onChange={(value) => {
                            setIsCustomerArchive(value);
                            getOrgCustomers('', 1, 10, value);
                          }}
                          placeholder="Customer Status"
                          style={{
                            width: '100px',
                          }}
                          options={customerOptionsArchive}
                        />
                      </div>
                    </div>
                  </div>
                )}
                loading={getOrgCustomersLoading}
                showHeader
                size="small"
                scroll="scroll"
                columns={productListColumns}
                dataSource={getCustomerssWithKey(orgCustomers?.customers || [])}
                pagination={orgCustomers?.count > 10 ? {
                  defaultCurrent: 1,
                  current: currentPage,
                  total: orgCustomers ? orgCustomers?.count : 0,
                  pageSize: 10,
                  onChange: (page) => {
                    setCurrentPage(page);
                    setSelectedRows([]);
                    setSelectedRowKeys(null);
                    getOrgCustomers(keyword, page, 10, isCustomerArchive);
                  },
                  position: ['bottomRight'],
                  showSizeChanger: false,
                } : false}
                rowSelection={(window.screen.width > 325) ? {
                  onChange: (rowKeys, rows) => {
                    setSelectedRows(rows);
                    setSelectedRowKeys(rowKeys);
                  },
                  selectedRowKeys,
                } : false}
              />
            </div>
            <div className="customer__wrapper-mobile">
              <div className="customer__mobile-title">
                {orgCustomers?.customers?.length || '0'}
                {' '}
                Registered Vendors
                {' '}
              </div>
              <div className="customer__mobile-body">
                {!getOrgCustomersLoading
                  ? orgCustomers?.customers?.filter((item) => item)?.splice(0, mobileVendorsLength)?.map((item) => (
                    <div key={item?.customer_id} className="customer__mobile-card-wrapper">
                      <div className="customer__mobile-card-title">
                        {' '}
                        {item.customer_name}
                        {' '}
                      </div>
                      <div className="customer__mobile-card-description">
                        <div className="customer__mobile-card-description-right">
                          <div className="customer__mobile-card-contact">
                            <MailOutlined />
                            {` ${item.email_address}` ? item.email_address : '-'}
                            <br />
                            <PhoneOutlined />
                            {' '}
                            {item.phone_number ? item.phone_number : ''}
                          </div>
                          <div className="customer__mobile-card-quantity">
                            {` ${item.count}` ? `${item.count} Customers` : ''}
                          </div>
                        </div>
                        <div className="customer__mobile-card-description-left">
                          <div
                            className="customer__mobile-card-view-button"
                            onClick={() => {
                              history.push(`/sales/customer/view/${item.customer_id}`);
                            }}
                          >
                            View
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                  : [1, 2, 3, 4].map((item) => (
                    <div className="ant-col-md-5 ant-col-xs-24" key={item}>
                      <div className="loadingBlock mobile__card-loader" />
                    </div>
                  ))}
                {!getOrgCustomersLoading && orgCustomers?.customers?.filter((item) => item).length >= mobileVendorsLength && (
                  <div className="customer__mobile-card-load-more-wrapper">
                    <Button
                      onClick={() => setMobileVendorsLength(mobileVendorsLength + 3)}
                      className="customer__mobile-card-load-more-button"
                    >
                      Load More
                    </Button>
                  </div>
                )}

              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
      <Drawer
        open={showNewCustomerModal}
        width="720px"
        mask
        onClose={() => setShowNewCustomerModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header">
            <H3Text text="Add New Customer" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewCustomerModal(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <CustomerForm
            callback={() => {
              getOrgCustomers('', currentPage, 10, isCustomerArchive);
              setShowNewCustomerModal(false);
            }}
            isAdmin
          />
        </div>
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, CustomerReducers,
}) => ({
  user: UserReducers.user,
  getOrgCustomersLoading: CustomerReducers.getOrgCustomersLoading,
  orgCustomers: CustomerReducers.orgCustomers,

});

const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId, limit, callback) =>
    dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback)),
  commonGetRequests: (payload, callback) => dispatch(AnalyticsActions.commonGetRequests(payload, callback)),
  getOrgCustomers: (keyword, page, limit, isCustomerArchive, callback) => dispatch(CustomerActions.getOrgCustomers(keyword, page, limit, isCustomerArchive, callback))
});

Customers.propTypes = {
  getTenants: PropTypes.func,
  getOrgCustomersLoading: PropTypes.bool,
  user: PropTypes.any,
  history: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Customers));
